import create from '~/misc/create';
import types from './types';
export const alterHideConfirm = (data) => {
  const payload = data;
  return (dispatch) => {dispatch(create(types.ALTER_HIDE_CONFIRM, payload));};
};



// WEBPACK FOOTER //
// ./src/modules/hideConfirm/actions.js